import { render } from "./MentionList.vue?vue&type=template&id=0e109f29"
import script from "./MentionList.vue?vue&type=script&lang=js"
export * from "./MentionList.vue?vue&type=script&lang=js"

import "./MentionList.vue?vue&type=style&index=0&id=0e109f29&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__